<template>
  <div id="chart">
    <apexchart
      type="line"
      height="400"
      :options="chartOptions"
      :series="series"/>
  </div>
</template>
<script>
export default {

  props: {
    events: {
      type: Object,
      default: () => ({})
    },
  },

  computed: {
    series() {
      return [
        {
          name: "Failed Logins",
          data: this.events.failed_logins.map(item => item.value)
        },
        {
          name: "Cookie Authentication",
          data: this.events.login.map(item => item.value)
        },
        {
          name: "API Token Authentication",
          data: this.events.api_login.map(item => item.value)
        },
      ]
    },
    chartOptions() {
      return {
        chart: {
          type: "line",
          toolbar: {
            show: true,
          },
        },
        colors: ["#f14668", "#00d1b2", "#efb762"],
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Authentication Events",
          align: "left",
          style: {
            color: "#efefef",
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          type: "datetime",
          categories: this.events.failed_logins.map(item => item.date),
          labels: {
            style: {
              colors: this.events.failed_logins.map(item => '#fff')
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: ['#fff']
            }
          },
          title: {
            text: "Security Events",
            style: {
              color: "#fff"
            },
          },
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          labels: {
            colors: ["#fff", "#fff"]
          }
        },
        tooltip: {
          theme: "dark",
        },
        grid: {
          show: true,
          borderColor: "#576475",
          strokeDashArray: 0,
          position: "back",
          yaxis: {
            lines: {
              show: true,
            },
          },
          row: {
            colors: undefined,
            opacity: 0.5,
          },
          column: {
            colors: undefined,
            opacity: 0.5,
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      }
    }
  }
}
</script>